import { AdServiceHelper } from '@/services/helper/adServiceHelper'

export default class NCTTracking {
  constructor () {
    this.baseTrackingData = {
      pvid: window.SiteInfo.TrackLibPageId,
      brand: this.getBrand(),
      country: window.PageConfig.country,
      reco: window.PageConfig.reco,
      var: document.querySelector('html').getAttribute('data-variant-name') || 'default',
      type: 'hidden',
      _c: '0',
      consent: 'unknown'
    }

    this.baseURL = (window.PageConfig.stage.includes('qa') || window.PageConfig.stage.includes('dev') ? '//absys-qa.' : '//absys.') + `${window.SiteInfo.brandShort}.${window.SiteInfo.tld}/`
    this.urlAddition = `${this.baseTrackingData.brand}/${this.baseTrackingData.brand}`
    this.eventPrefix = (window.PageConfig.site === 'hp' ? 'homepage' : 'logout') + '.startseite.event'

    this.events = {
      ovk: `s?name=${this.eventPrefix}.ovk`,
      documentReady: `${this.urlAddition}/s?name=${this.eventPrefix}.performance.documentReady.5`,
      windowLoad: `${this.urlAddition}/s?name=${this.eventPrefix}.performance.windowLoad.6`
    }

    AdServiceHelper.listenEvent('adblock.detectionfinished', (event) => {
      let adb = 0

      if (window.AdService.info?.abd()?.details?.type?.css) {
        adb = window.AdService.info?.abd()?.details?.fyi?.acceptable ? 3 : 1
      }
      if (window.AdService.info?.abd()?.details?.type?.request) {
        adb = window.AdService.info?.abd()?.details?.fyi?.private ? 4 : 2
      }
      this.makeRequest(this.getURL(this.events.ovk, { adb }))
    })

    // Performance-Tracking for only 5% of views
    if (Math.floor(Math.random() * (100 - 1)) + 1 <= 5 || new URLSearchParams(window.location.search).has('performance')) {
      document.addEventListener('DOMContentLoaded', () => {
        this.makeRequest(this.getURL(this.events.documentReady, { period: new Date().getTime() - window.startupTS }))
      })

      window.addEventListener('load', () => {
        this.makeRequest(this.getURL(this.events.windowLoad, { period: new Date().getTime() - window.startupTS }))
      })
    }
  }

  getBrand () {
    const brand = window.SiteInfo.brandShort
    return brand === 'web' ? 'webde' : brand?.includes('gmx') ? 'gmx' : brand
  }

  makeRequest (url) {
    const track = new Image(1, 1)
    track.src = url
  }

  getURL (trackingEvent, additionalTrackingData) {
    const trackingData = Object.assign({}, this.baseTrackingData, additionalTrackingData)

    try {
      window.__tcfapi(
        'getPermission',
        2,
        (valid) => {
          if (!valid) {
            if (trackingData.hasOwnProperty('pvid')) {
              trackingData.pvid = ''
            }
            if (trackingData.hasOwnProperty('var')) {
              trackingData.var = ''
            }
          }
        },
        'brainTracking'
      )
      window.__tcfapi(
        'getConsentState',
        2,
        (consentState) => {
          const stateMap = {
            fullConsent: 'full',
            partialConsent: 'partial',
            noConsent: 'optout',
            unknown: 'unknown'
          }
          trackingData.consent = stateMap[consentState] || stateMap.unknown
        }
      )
    } catch (e) {}

    let url = `${this.baseURL}${trackingEvent}&ts=${new Date().getTime()}`

    Object.entries(trackingData).forEach(([key, value]) => {
      url += `&${key}=${value}`
    })

    return url
  }
}
